export const TypesContactsActionTypes = {
  API_RESPONSE_SUCCESS: '@@types-contacts/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@types-contacts/API_RESPONSE_ERROR',

  GET_TYPES_CONTACTS: '@@types-contacts/GET_TYPES_CONTACTS',
  LIST_TYPES_CONTACTS: '@@types-contacts/LIST_TYPES_CONTACTS',
  ADD_TYPES_CONTACTS: '@@types-contacts/ADD_TYPES_CONTACTS',
  UPDATE_TYPES_CONTACTS: '@@types-contacts/UPDATE_TYPES_CONTACTS',
  DELETE_TYPES_CONTACTS: '@@types-contacts/DELETE_TYPES_CONTACTS',

  RESET: '@@types-contacts/RESET'
}
